// extracted by mini-css-extract-plugin
export default {"result":"ResultAlert_result__+WF+V","button":"ResultAlert_button__q99XK","platform":"ResultAlert_platform__Mdeyi","blue":"ResultAlert_blue__ZgHLd","red":"ResultAlert_red__OvgbB"};